import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";

import { Logo } from "@/components/logo";
import { VerticalEpisodeDisplay } from "@/components/vertical-episode-display";
import { apiClient } from "@/lib/api";
import type { OnAirEpisode } from "@/lib/episodes";
import type { ApiEnvelope } from "@/lib/page-data";

const getOnAir = async (): Promise<OnAirEpisode | null> => {
  const req =
    await apiClient.get<ApiEnvelope<OnAirEpisode | null>>("/api/episodes/now");
  const details = req.data.details ?? null;
  return details;
};

const Popout = () => {
  const [episode, setEpisode] = useState<OnAirEpisode | null>(null);

  useEffect(() => {
    const run = async () => {
      const ep = await getOnAir();
      setEpisode(ep);
    };

    run();
  }, []);

  return (
    <div className="flex flex-col items-center gap-12 p-10">
      <Logo />

      {episode && <VerticalEpisodeDisplay episode={episode} />}
    </div>
  );
};

export const Route = createFileRoute("/popout")({
  component: Popout,
});
